import React, {createContext, PropsWithChildren} from 'react';

export const SERVER_AUTH_TOKEN_HEADER = 'X-Customer-Token';

export const useServerCustomerAuthToken = () => {
  const context = React.useContext(ctx);
  return context.authToken;
};

export const SeverCustomerAuthTokenProvider: React.FC<
  PropsWithChildren<ContextValue>
> = ({children, authToken}) => {
  return <ctx.Provider value={{authToken}}>{children}</ctx.Provider>;
};

type ContextValue = {
  authToken?: string;
};

const ctx = createContext<ContextValue>({
  authToken: undefined,
});
